import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class Position {
  accountNumber = ""
  averageOpenPrice = ""
  averageDailyMarketClosePrice = ""
  closePrice = ""
  costEffect = ""
  deliverableType = ""
  expiresAt = ""
  instrumentType = ""
  multiplier = 0
  quantity = ""
  quantityDirection = ""
  realizedDayGain = ""
  realizedDayGainEffect = ""
  realizedDayGainDate = ""
  realizedToday = ""
  realizedTodayEffect = ""
  realizedTodayDate = ""
  symbol = ""
  underlyingSymbol = ""
}

export const POSITION_DESER: SchemaDeSer<Position> = new SchemaDeSerBuilder(
  Position
)
  .ofStrings(
    "accountNumber",
    "averageOpenPrice",
    "averageDailyMarketClosePrice",
    "closePrice",
    "costEffect",
    "deliverableType",
    "expiresAt",
    "instrumentType",
    "quantity",
    "quantityDirection",
    "realizedDayGain",
    "realizedDayGainEffect",
    "realizedDayGainDate",
    "realizedToday",
    "realizedTodayEffect",
    "realizedTodayDate",
    "symbol",
    "underlyingSymbol"
  )
  .ofInt("multiplier")
  .toDeSer()
